import BaseReducer from "@common/redux/reducers/BaseReducer";
import {
  getCurrentDateTime,
  getDatePart,
  getTimePart,
} from "@common/components/helpers/datetime";

class CustomerIncidentReducer extends BaseReducer {
  domain = "CustomerIncident";
  type = "View";

  initialState = {
    id: null,
    customerIncidentTypes: [],
    customerUnknown: false,
    date: getDatePart(getCurrentDateTime()),
    time: getTimePart(getCurrentDateTime()),
    customerIncidentType: null,
    customers: [],
    customerIds: [],
    description: "",
    capturedByCctv: null,
    injuries: null,
    injuryDetails: "",
    esCalled: null, // Emergency Service
    esTypes: [],
    ambulanceDetails: "",
    timeServicesContacted: getTimePart(getCurrentDateTime()),
    servicesDidNotAttend: false,
    timeServicesArrived: getTimePart(getCurrentDateTime()), // if empty - did not attend
    incidentNumber: "",
    comments: "",
    incidentRecord: null,
    customerRecord: null,
    officerRecord: null,
    incidentType: null,
    officerType: null,
    type: 1,
  };
}

const reducer = new CustomerIncidentReducer();

export default reducer;
